import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AddWidgetButton } from './AddWidgetButton';

interface WidgetInsertionZoneProps {
  onAddWidget: (type: string, config: any, index?: number) => void;
  index: number;
  isEditMode: boolean;
  className?: string;
}

export const WidgetInsertionZone: React.FC<WidgetInsertionZoneProps> = ({
  onAddWidget,
  index,
  isEditMode,
  className
}) => {
  if (!isEditMode) return null;

  return (
    <div className={cn(
      'flex items-center justify-center',
      'border-2 border-dashed border-primary/20 rounded-lg bg-background/80',
      'hover:border-primary/40 hover:bg-primary/5',
      'opacity-0 hover:opacity-100 transition-all duration-200',
      'group cursor-pointer backdrop-blur-sm',
      className
    )}>
      <div className="flex items-center gap-2 text-muted-foreground group-hover:text-primary transition-colors">
        <AddWidgetButton 
          onAdd={onAddWidget} 
          index={index}
        />
        <span className="text-xs font-medium">Ajouter</span>
      </div>
    </div>
  );
};